<!--
  리뷰 스와이퍼(Radial) 내 rate UI 컴포넌트
-->
<template>
  <div class="review_rate">
    {{ rate }}
  </div>
</template>

<script>
export default {
  name: 'CompReviewRate',
  props: {
    rate: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate () {

  },
  created () {

  },
  beforeMount () {

  },
  mounted () {

  },
  beforeUpdate () {

  },
  updated () {

  },
  beforeDestroy () {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompReviewRate.vue